export const DIVIDER_STYLES = [
  { value: 'solid', name: 'divider.style.solid' },
  { value: 'dashed', name: 'divider.style.dashed' },
  { value: 'dotted', name: 'divider.style.dotted' }
];
